import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import clsx from 'clsx';
import { twMerge } from '@belong/common';
import { Image } from '../Image/Image.js';
import { Text } from '../Text/Text.js';
import { IDENTITY_VERIFICATION_SUPPORTED_DOCUMENTS } from './IdentityVerificationBanner.constants.js';
import { IDENTITY_VERIFICATION_BANNER_STRINGS } from './IdentityVerificationBanner.strings.js';

function IdentityVerificationBanner({
  verificationStatus,
  className
}) {
  const isManualReviewRequired = verificationStatus === 'RequiresManualReview';
  const isIdentified = verificationStatus === 'Passed';
  const sharedBannerClassName = 'flex flex-col border border-solid rounded p-sm mt-xl';
  return jsx("div", {
    className: "relative w-full",
    children: isManualReviewRequired ? jsxs("div", {
      className: clsx(sharedBannerClassName, 'items-center justify-center border-gray bg-light-gray'),
      children: [jsx("div", {
        style: {
          width: 345,
          height: 192
        },
        children: jsx(Image, {
          src: "/residents/id_review_required.svg",
          alt: "Id Review Required"
        })
      }), jsx(Text, {
        className: "mt-xl hover:cursor-default",
        children: IDENTITY_VERIFICATION_BANNER_STRINGS.manual_review_required
      })]
    }) : jsxs(Fragment, {
      children: [isIdentified && jsx("div", {
        className: "absolute inset-0 z-[1] flex items-center justify-center",
        children: jsx("div", {
          className: "flex h-button max-h-full w-9/12 -rotate-12 items-center justify-center rounded bg-green text-white shadow-button md:w-button-default",
          children: jsx(Text, {
            fontWeight: "semibold",
            className: "hover:cursor-default",
            children: IDENTITY_VERIFICATION_BANNER_STRINGS.completed
          })
        })
      }), jsxs("div", {
        className: twMerge(clsx('mt-xl', isIdentified && 'opacity-50'), className),
        children: [jsx("div", {
          className: "flex items-center justify-center rounded-t border border-solid border-green bg-green/10 px-sm py-xs",
          children: jsx(Text, {
            fontWeight: "semibold",
            children: IDENTITY_VERIFICATION_BANNER_STRINGS.title
          })
        }), jsx("div", {
          className: "grid grid-cols-1 justify-between gap-xs rounded-b border border-t-0 border-solid border-green bg-green/[0.01] p-sm lg:grid-cols-2",
          children: IDENTITY_VERIFICATION_SUPPORTED_DOCUMENTS.map((method, index) => jsxs("div", {
            className: "flex items-center",
            children: [jsx("div", {
              style: {
                width: 50
              },
              className: "mr-2sm h-xl",
              children: jsx(Image, {
                alt: "passport",
                src: `/residents/${method.src}`
              })
            }), jsx(Text, {
              fontWeight: "semibold",
              variant: "p1",
              children: method.title
            })]
          }, index))
        })]
      })]
    })
  });
}

export { IdentityVerificationBanner };
